import { makeAutoObservable } from 'mobx';

type Breadcrumbs = {
  url: string;
  title: string;
  badge?: { text: string; colors: { color: string; backgroundColor: string } };
}[];

class BreadcrumbsStore {
  breadcrumbs: Breadcrumbs = [{ url: '/', title: 'Home' }];

  constructor() {
    makeAutoObservable(this);
  }

  set(crumbs: Breadcrumbs): void {
    this.breadcrumbs = crumbs;
  }
}

export default BreadcrumbsStore;
